export class PauseScene extends Phaser.Scene {
  constructor() {
    super({ key: "PauseScene" });
  }

  create(data: any) {
    const { width, height } = this.sys.game.scale.gameSize;


    // (optional) dim overlay behind buttons
    // this.add.rectangle(0, 0, width, height, 0x000000, 0.4).setOrigin(0);

    // Resume image button
    const resume = this.add
      .image(width / 2, height / 2 - 80, "resumeButton")
      .setOrigin(0.5)
      .setInteractive({ useHandCursor: true });

    resume.on("pointerdown", () => {
      const parentScene: any = this.scene.get(data.parent);

      // Clear blur from gameplay camera (safe if postFX missing)
       parentScene.cameras.main.postFX?.clear?.();
       parentScene._pauseBlur = null;

      // Close pause UI, resume gameplay
      this.scene.stop();
      this.scene.resume(data.parent);
    });

    // Exit image button
    const exit = this.add
      .image(width / 2, height / 2 + 200, "exitButton")
      .setOrigin(0.5)
      .setInteractive({ useHandCursor: true });

    exit.on("pointerdown", () => {
      const parentScene: any = this.scene.get(data.parent);

      // Clear blur before leaving
       parentScene.cameras.main.postFX?.clear?.();
       parentScene._pauseBlur = null;

      this.scene.stop(data.parent);
      this.scene.remove(data.parent); // keep if you truly want it removed from SceneManager
      this.scene.stop();

      if (data.parent === "LevelScene") {
        this.scene.start("SelectLevelScene");
      } else {
        this.scene.start("MainMenu");
      }
    });
  }
}
